import { useEffect } from "react";

function CustomerPageFilter(props) {
  useEffect(() => {}, [props?.bulkActionData]);


  const handleChange = value => {
    props.onFilterSelect(value);
  };

  return (
    <>



      <select  onChange={handleChange} class="block w-md mt-1 mr-5 p-2 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" aria-label="select">
            <option   value="17" >All</option>
            <option value="22"> Active</option>
            <option value="23">InActive</option>
            <option value="24">Subscribed</option>
            <option value="25">No Subscription</option>
            <option value="26">Wallet Deposited</option>
            <option value="27">Wallet Not Deposited</option>
        </select>
    </>
  );
}

export default CustomerPageFilter;
